import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/photo/:name',
      name: 'photo',
      component: () => import(/* webpackChunkName: "about" */ './views/Photo.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import(/* webpackChunkName: "about" */ './views/Contact.vue')
    },
    {
      path: '/bureau',
      name: 'bureau',
      component: () => import(/* webpackChunkName: "about" */ './views/Bureau.vue')
    },
    {
      path: '/sdb',
      name: 'sdb',
      component: () => import(/* webpackChunkName: "about" */ './views/Sdb.vue')
    },
    {
      path: '/cuisine',
      name: 'cuisine',
      component: () => import(/* webpackChunkName: "about" */ './views/Cuisine.vue')
    },
    {
      path: '/chambre',
      name: 'chambre',
      component: () => import(/* webpackChunkName: "about" */ './views/Chambre.vue')
    },
    {
      path: '/dressing',
      name: 'dressing',
      component: () => import(/* webpackChunkName: "about" */ './views/Dressing.vue')
    },
    {
      path: '/salon',
      name: 'salon',
      component: () => import(/* webpackChunkName: "about" */ './views/Salon.vue')
    },
    {
      path: '/combles',
      name: 'combles',
      component: () => import(/* webpackChunkName: "about" */ './views/Combles.vue')
    },
    {
      path: '/bibliotheque',
      name: 'bibliotheque',
      component: () => import(/* webpackChunkName: "about" */ './views/Bibliotheque.vue')
    }
  ]
})
